import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import ApiRoute from "../../../../helper/api";

export default function OrderExternalOrderNumber({order, setOrder}) {
    const [externalOrderNumber, setExternalOrderNumber] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setExternalOrderNumber(order?.metadata?.external_order_number ?? "");
    }, [order?.metadata?.external_order_number]);

    async function handleSave() {
        const value = externalOrderNumber.trim();

        if (!value) {
            toast.error("شماره سفارش خارجی نمی‌تواند خالی باشد.");
            return;
        }

        if (externalOrderNumber.length > 255) {
            toast.error("شماره سفارش خارجی نباید بیشتر از ۲۵۵ کاراکتر باشد.");
            return;
        }

        setIsSaving(true);
        try {
            const response = await ApiRoute.order.externalOrderNumber.fn(order._id, externalOrderNumber);
            const updatedExternalOrderNumber = response?.results?.metadata?.external_order_number;

            if (updatedExternalOrderNumber === undefined) {
                // API validation errors are displayed by the shared API client.
                return;
            }

            setOrder((currentOrder) => ({
                ...currentOrder,
                metadata: {
                    ...currentOrder.metadata,
                    external_order_number: updatedExternalOrderNumber
                }
            }));
            toast.success("شماره سفارش خارجی با موفقیت ذخیره شد.");
        } catch (error) {
            toast.error("ذخیره شماره سفارش خارجی با خطا مواجه شد.");
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <div className="flex-col pb-3 border-b border-b-gray-7 mt-4">
            <label className="block mb-2" htmlFor="external-order-number">شماره سفارش خارجی</label>
            <div className="flex gap-2">
                <input
                    id="external-order-number"
                    type="text"
                    className="input text-left !mr-0 flex-1"
                    value={externalOrderNumber}
                    disabled={isSaving}
                    onChange={(event) => setExternalOrderNumber(event.target.value)}
                />
                <button
                    type="button"
                    onClick={handleSave}
                    disabled={isSaving}
                    className="btn btn-green text-sm rounded p-2 min-w-16"
                >
                    {isSaving ? "در حال ذخیره..." : "ذخیره"}
                </button>
            </div>
        </div>
    );
}
